import angular from 'angular';

class invoiceStatementsCtrl {
    /* @ngInject */
    constructor(
        PrincipalSvc,
        $location,
        $state,
        AuthSvc,
        logger
    ) {
        this.PrincipalSvc = PrincipalSvc;
        this.$location = $location;
        this.$state = $state;
        this.AuthSvc = AuthSvc;
        this.logger = logger;
    }


     $onInit() {
        this.resetPrincipal = angular.copy(this.principal);        
    }


    back() {
        this.$state.go('do', { tabName: 'principal' });
    }
    cancel() {
        this.principal = angular.copy(this.resetPrincipal);
    }
    update() {
        if (this.form.$valid) {
            this.PrincipalSvc.updatePrincipal(this.principal).then(
                data => {
                    this.form.$setPristine();
                    this.logger.success('success.update', data, null, { entityName: "Le Donneur d'ordre" });
                },
                error => {
                    this.logger.error('error.update', error);
                }
            );
        }
    }

    isEditAuthorized() {
        return this.AuthSvc.isEditAuthorized();
    }
}

angular.module('app.principal').component('invoiceStatements', {
    templateUrl: require('./invoice-statements.html'),
    controller: invoiceStatementsCtrl,
    bindings: {
        principal: '<',
    },
});
